import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FormFieldBase } from './form-field-base';
import { FormService } from '@modules/creator/components/special-block/forms/services/form.service';

@Component({
    selector: '[form-field-textarea]',
    styles: [`
    mat-form-field {
      width: 100%;
      font-family: inherit !important;
      font-size: inherit !important;
      line-height: inherit !important;
      letter-spacing: inherit !important;
      font-kerning: inherit !important;
      font-weight: inherit !important;
      text-transform: inherit !important;
      color: inherit !important;
      font-style: inherit !important;
      text-decoration: inherit !important;
      text-shadow: inherit !important;
      text-align: inherit !important;
    }

    textarea {
      height: 140px;
    }
  `],
    template: `
    <div [formGroup]="formGroup">
      <mat-form-field appearance="outline">
        <mat-label>{{ item.content }}</mat-label>
        <textarea matInput
                  [type]="inputType"
                  [formControlName]="formName"
                  (keyup)="onKey($event)"
                  [attr.aria-label]="item.content || null"
                  [tabIndex]="item.tabindex"
                  [required]="required"
                  [attr.maxlength]="maxLength"
                  (ngModelChange)="dataChanged($event)"
        ></textarea>
        <mat-error *ngIf="invalid">{{ getErrorMessage$() | async | translate }}</mat-error>
      </mat-form-field>
    </div>
  `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class FormFieldTextareaComponent extends FormFieldBase {
  constructor(fs: FormService) {
    super(fs);
  }
}
